import type { Ref } from 'vue';
import type { MinifiedSecondaryNavigation } from '~/types/MinifiedSecondaryNavigation';

export default defineNuxtPlugin(() => {
  const secondaryNavigation: Ref<MinifiedSecondaryNavigation | null> =
    useState<MinifiedSecondaryNavigation | null>(
      'secondaryNavigation',
      () => null
    );

  return {
    provide: {
      secondaryNavigation
    }
  };
});
